import { render } from "./dialog-upload-salary.vue?vue&type=template&id=faee58ae&scoped=true&ts=true"
import script from "./dialog-upload-salary.vue?vue&type=script&lang=ts"
export * from "./dialog-upload-salary.vue?vue&type=script&lang=ts"

import "./dialog-upload-salary.vue?vue&type=style&index=0&id=faee58ae&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faee58ae"]])

export default __exports__